/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Package, Package$inboundSchema } from "./package.js";
import {
  PackageVersion,
  PackageVersion$inboundSchema,
} from "./packageversion.js";

export type PublishPackageResult = {
  package: Package;
  version: PackageVersion;
};

/** @internal */
export const PublishPackageResult$inboundSchema: z.ZodMiniType<
  PublishPackageResult,
  unknown
> = z.object({
  package: Package$inboundSchema,
  version: PackageVersion$inboundSchema,
});

export function publishPackageResultFromJSON(
  jsonString: string,
): SafeParseResult<PublishPackageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PublishPackageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PublishPackageResult' from JSON`,
  );
}
